const foreign_labor_data = {
  title: `Foreign Labor Recruiter Profiles`,
  body: `Select the Foreign Labor Recruiter Profiles to add to Appendix D.`,
  table: {
    th: [
      "First Name",
      "Last Name",
      "Name of Employer/Recruiting Organization",
      "City",
      "State",
      "Country",
    ],
    td: [
      "first_name",
      "last_name",
      "employer_name",
      "city",
      "state",
      "country",
    ],
  },
  new_profile(profile) {
    return {
      id: profile.id,
      recruiter_name: profile.recruiter_name,
      fl_recr_first_name: profile.fl_recr_first_name,
      fl_recr_middle_name: profile.fl_recr_middle_name,
      fl_recr_employer_name: profile.fl_recr_employer_name,
      fl_recr_country_id: profile.fl_recr_country_id,
      fl_recr_city: profile.fl_recr_city,
      fl_recr_state_id: profile.fl_recr_state_id,
      fl_recr_province: profile.fl_recr_province,
    };
  },
};

export default foreign_labor_data;
